import { IRoundBet } from "../../core/round/interfaces";
import { EntityState } from "@ngrx/entity";

export namespace StatisticsState {
    export const featureKey: string = "statistics";
}

export interface IStatisticsState {
    myBets: EntityState<IRoundBet>;
    lastModified: number;
    reachedLastPage: boolean;
}
